/**
 * TanStack Query hooks for `igaming-responsible-gambling-filters-self-excluded`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	igamingResponsibleGamblingFiltersSelfExcludedQueryKeys,
	type CreateIgamingResponsibleGamblingFiltersSelfExcludedBody,
	type ListIgamingResponsibleGamblingFiltersSelfExcludedResponse,
	type IgamingResponsibleGamblingFiltersSelfExcludedRow,
} from "./api";

export function useIgamingResponsibleGamblingFiltersSelfExcludedList(): UseQueryResult<ListIgamingResponsibleGamblingFiltersSelfExcludedResponse, Error> {
	return useQuery({
		queryKey: igamingResponsibleGamblingFiltersSelfExcludedQueryKeys.list(),
		queryFn: list,
	});
}

export function useIgamingResponsibleGamblingFiltersSelfExcludedCreate(): UseMutationResult<IgamingResponsibleGamblingFiltersSelfExcludedRow, Error, CreateIgamingResponsibleGamblingFiltersSelfExcludedBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: igamingResponsibleGamblingFiltersSelfExcludedQueryKeys.all });
		},
	});
}

export function useIgamingResponsibleGamblingFiltersSelfExcludedDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: igamingResponsibleGamblingFiltersSelfExcludedQueryKeys.all });
		},
	});
}
